export default __webpack_public_path__ + "static/media/webhooks.4605d1b1.svg";